import { render, staticRenderFns } from "./VersionMore.vue?vue&type=template&id=a144c1ca"
import script from "./VersionMore.vue?vue&type=script&lang=js"
export * from "./VersionMore.vue?vue&type=script&lang=js"
import style0 from "./VersionMore.vue?vue&type=style&index=0&id=a144c1ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports